// extracted by mini-css-extract-plugin
module.exports = {"tier-badge__image":"lMoq6","tier-badge":"_1_5R7","tier-badge--silver":"_2cIK9","tier-badge--gold":"_20p7n","tier-badge--platinum":"_2961V","tier-badge--gradient":"_3OWwo"};